<div class="riskscape-map-container">
    <div class="relative">
        <div id="map"></div>
        <input id="search" type="text" placeholder="Start typing to search" class="search">        
    </div>
</div>
